export default class {
  constructor() {
    let animationFrameId = null;

    // ユーザーの手動操作があった場合はアニメーションを中断
    const cancelScroll = () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      }
    };

    window.addEventListener("wheel", cancelScroll, { passive: true });
    window.addEventListener("touchstart", cancelScroll, { passive: true });

    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        const href = anchor.getAttribute("href");
        if (!href) return;

        // hrefが "#" または空の場合はページトップへ、それ以外は対象要素を取得
        const target = href === "#" || href === "" ? document.documentElement : document.querySelector(href);
        if (!target) return;

        // デフォルトの挙動（パッと切り替わる動作）を止める
        e.preventDefault();
        cancelScroll();

        // ヘッダーや管理バーの高さを動的に取得
        const getHeaderOffset = () => {
          const header = document.querySelector(".l-header");
          const wpAdminBar = document.getElementById("wpadminbar");
          const headerHeight = header ? header.offsetHeight : 0;
          const wpAdminBarHeight = wpAdminBar ? wpAdminBar.offsetHeight : 0;
          return headerHeight + wpAdminBarHeight;
        };

        const startY = window.scrollY;
        const startTime = performance.now();
        const duration = 700; // スクロールにかける時間 (ms)

        // イージング関数 (滑らかに減速する easeOutCubic)
        const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

        const step = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const ease = easeOutCubic(progress);

          // スクロール途中に画像ロードやアニメーション等で位置が変わっても最新のターゲット座標を取得
          const currentTargetY = target === document.documentElement
            ? 0
            : Math.max(0, target.getBoundingClientRect().top + window.scrollY - getHeaderOffset());

          const newY = startY + (currentTargetY - startY) * ease;
          window.scrollTo(0, newY);

          if (progress < 1) {
            animationFrameId = requestAnimationFrame(step);
          } else {
            // アニメーション完了時に最終的な目的地へ正確に吸着
            const finalTargetY = target === document.documentElement
              ? 0
              : Math.max(0, target.getBoundingClientRect().top + window.scrollY - getHeaderOffset());
            window.scrollTo(0, finalTargetY);
            animationFrameId = null;
          }
        };

        animationFrameId = requestAnimationFrame(step);
      });
    });
  }
}
